<!-- 任务1 -->
<template>
    <div>
      <div class="course_Task1">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">任务得分：10 分 学习时长：50分钟</p>
          </template>
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：</p>
          <p style="min-height: 21px;">{{taskInfo.taskTitle}}</p>
          <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：</p>
          <p style="min-height: 21px;">{{taskInfo.taskScore}}分</p>
          <p class="fontB"><i class="el-icon-document-copy icon_"></i>考核内容：</p>
          <el-row class="aljj">
            <p>1、至少观看{{taskInfo.assessmentRequirements}}分钟视频</p>
            <p>2、每隔{{taskInfo.assessmentTime}}分钟弹出一次验证框</p>
          </el-row>
          <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>考核任务：</p>
          <el-row>
            <el-col :span="12">
              <el-table
                border
                :data="tableData"
                style="width: calc(100% - 20px);">
                <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
                <el-table-column prop="fileName" header-align="center" align="center" label="视频名称"></el-table-column>
                <el-table-column prop="jd" header-align="center" align="center" label="进度" width="100">
                  <template slot-scope="scope">
                    <span style="color: #F83131;">{{scope.row.jd  || '-'}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="_" header-align="center" align="center" label="操作" width="120">
                  <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="seeVideo(scope.row)">{{scope.row.jd == 0?"观看":"继续观看"}}</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12">
              <el-row style="width: 100%;height: 300px">
                <video @timeupdate="onTimeupdate" id="myVideo" style="width: 100%;height: 100%;" class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="allow" poster="" webkit-playsinline playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto">
                    <source type="application/x-mpegURL">
                </video>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>

export default {
  name: 'Task1',
  props: {
    examType: { //考试类型 1：考试 2：查看成绩
      type: String,
      default: function(){
        return 1;
      }
    },
    taskId: { //任务ID
      type: String,
      default: function(){
        return "";
      }
    },
  },
  data() {
    return {
      tableData: [],
      player:null,
      taskInfo:{} //任务详情
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    getInfo(){ //获取详情
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do",{taskId:this.taskId}).then((ret) =>{
        if(ret.code == 0){
          this.taskInfo = ret.data;
          this.tableData = ret.data.teacherOpenCourseHandsOnSimulationTasksFileList;
          this.initVideo();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    initVideo() {
      let videoUrl = "";
      if(!this.$isEmpty(this.tableData) && this.tableData.length > 0){
        videoUrl = this.$isHttp(this.tableData[0].fileUrl);
      }
      let this_ = this;
      this.player = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: false,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          autoDisable: true,
          //设置视频播放器的显示宽度（以像素为单位）
          // playbackRates: [0.5, 1, 1.5, 2],
          sources:[ // 视频源
            {
              src:  videoUrl,
              poster: '',
              type:videoUrl.indexOf(".mp4")>=0?'video/mp4':'video/webm'
            }]
      }, function onPlayerReady() {
        //this_.player.currentTime(5); //指定视频的开始播放位置
      });
    },
    seeVideo(item){ //查看视频
      this.player.src({src:this.$isHttp(item.fileUrl),type:item.fileUrl.indexOf(".mp4")>=0?'video/mp4':'video/webm'});
      this.player.play(); //播放
    },
    onTimeupdate(e){ //判断是否播放完成

    },

  },
  beforeDestroy(key) { //退出时
    if (this.player) {
        this.player.dispose();
    }
  }
};
</script>
<style  lang="less">
  .course_Task1{
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .has-gutter{
      th{
        border-color:#E5E5E5;
        background-color: #EFF2F7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/PracticalTraining/Task1.vue